import { useCallback, useEffect, useState } from "react";
import { Check, Flag, X } from "lucide-react";
import { adminApi } from "../../lib/adminApi";

export const ModerationTab = () => {
  const [reports, setReports] = useState(null);

  const load = useCallback(async () => {
    const { data } = await adminApi.get("/admin/reports");
    setReports(data);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const resolve = async (id, action) => {
    await adminApi.post(`/admin/reports/${id}/resolve`, { action });
    load();
  };

  if (!reports) return <p className="text-sm text-cream/50">Loading reports…</p>;

  return (
    <div data-testid="moderation-tab">
      {reports.length === 0 ? (
        <div className="rounded-3xl border border-cream/10 px-6 py-12 text-center" data-testid="moderation-empty">
          <Flag className="mx-auto h-8 w-8 text-gold/50" />
          <p className="mt-4 font-serif text-2xl text-cream">Nothing reported.</p>
          <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-cream/50">
            When the app launches, reported profiles and flagged content land here with the report reason and approve/reject actions.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {reports.map((r) => (
            <div key={r.id} className="rounded-3xl border border-cream/10 p-6" data-testid={`report-row-${r.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-semibold text-cream/85">{r.subject || r.reported_user || "Reported content"}</p>
                  <p className="mt-1 text-sm leading-relaxed text-cream/55">{r.reason}</p>
                  <p className="mt-2 text-xs uppercase tracking-[0.15em] text-cream/35">
                    {r.status || "pending"} · {r.reported_at ? new Date(r.reported_at).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : ""}
                  </p>
                </div>
                {(r.status || "pending") === "pending" && (
                  <div className="flex gap-2">
                    <button onClick={() => resolve(r.id, "approve")} data-testid={`report-approve-${r.id}`} className="flex items-center gap-1.5 rounded-full border border-gold/40 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-gold transition-colors hover:bg-gold hover:text-ink">
                      <Check className="h-3 w-3" /> Approve
                    </button>
                    <button onClick={() => resolve(r.id, "reject")} data-testid={`report-reject-${r.id}`} className="flex items-center gap-1.5 rounded-full border border-red-500/40 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.12em] text-red-400 transition-colors hover:bg-red-500 hover:text-cream">
                      <X className="h-3 w-3" /> Reject
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
